export default "/images/48f2d681734437146949b9dccb4185bc.avif";